<template>
  <div class="search-by-bags">
    <b-form-checkbox
      v-model="included_checked_bags_only"
      id="checkbox-included_checked_bags_only"
      name="checkbox-included_checked_bags_only"
      value="1"
      unchecked-value="0"
      @change="handle_change"
    >
      Bagagli inclusi
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'search-by-bags',
  created() {
    document.body.classList.remove('overflow-hidden');
  },
  computed: {
    included_checked_bags_only: {
      get() {
        return this.$store.state.liveflight.included_checked_bags_only !== undefined
          ? this.$store.state.liveflight.included_checked_bags_only
          : 0;
      },
      set(value) {
        this.$store.commit('included_checked_bags_only', value);
      },
    },
  },
  methods: {
    handle_change() {
      //this.log('[CHANGE]: included_checked_bags_only = '+this.included_checked_bags_only)
      window.eventBus.$emit('change-search-by', {
        included_checked_bags_only: this.included_checked_bags_only,
      });
    },
  },
};
</script>

<style lang="scss">
.search-by-bags {
  @include liveflight-checkbox;
}
</style>
